export default __webpack_public_path__ + "static/2.5.2/media/diagmaticLogo.c8db828e.svg";